/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteFeV1EventsId$Params {

/**
 * The hashed event ID.
 */
  id: string;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
}

export function deleteFeV1EventsId(http: HttpClient, rootUrl: string, params: DeleteFeV1EventsId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteFeV1EventsId.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteFeV1EventsId.PATH = '/v1/events/{id}';
